import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ImportedTagDefinition } from '../../models/';
import { ItagsImportService, ITagDefinitionService, ILoggerService } from '../../services/';
import { importConnectionPointTypes, defaultItemPerPage, tagsImported, tagSelected, tagSaved } from '../../common/';

class DahsTagsSearchController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    searchString: string;
    selectedConnectionPoint: string;
    isSearching: boolean;
    results: ImportedTagDefinition[];
    displayed: ImportedTagDefinition[];
    pageNumber = 1;
    pageSize = defaultItemPerPage;
    pageCount: number;
    newResultsCount: number;
    types = importConnectionPointTypes;
    isDirty: boolean;
    modal: string;
    exposedScope: {
        more: () => void;
        less: () => void;
    };
    hasMore = false;
    hasLess = false;
    hasModel = false;
    searchEnable = {
        name: true,
        unit: true,
        comment: true,
        group: false,
        variable: false,
        source: false,
        err: false,
        message: false,
        user: false,
        severity: false,
        app: false,
        tag: false,
        unused: true,
        ne: true
    };
    selectedImportTag: ImportedTagDefinition;
    searchFormat = {
        unused: d => String(!d.isInUse),
        ne: d => String(!d.isAlreadyExisting)
    };

    addmethod: (data: { tagImport: ImportedTagDefinition[] }) => angular.IPromise<number[]>;

    static $inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        'tagsImportService',
        'tagDefinitionService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _$stateParams: angular.ui.IStateParamsService,
        private _tagsImportService: ItagsImportService,
        private _tagService: ITagDefinitionService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.results = [];
        this.newResultsCount = 0;

        this._$scope.$watch(() => this.searchString, (newValue, oldValue) => {
            this.isDirty = !!newValue;
        });

        this._$scope.$on(tagsImported, (event, data: ImportedTagDefinition[]) => {
            const imported = data;
            const reload = [];
            this.results.forEach(r => {
                const found = imported.find(i => i.name.toLowerCase() === r.name.toLowerCase());
                if (found) {
                    r.isAlreadyExisting = true;
                    reload.push(found.guid);
                }
            });
            this.isSearching = true;
            this._tagService.getByGuids(reload).then(tags => {
                tags.forEach(tag => {
                    const found = this.results.find(r => r.name.toLowerCase() === tag.tagDefinition.name.toLowerCase());
                    if (found) {
                        found.tagDefinition = tag.tagDefinition;
                    }
                });
            }).finally(() => this.isSearching = false);
        });

        this._$scope.$on(tagSaved, (e, data) => {
            this.search();
        });

        if (this._$stateParams['connectionPointGuid']) {
            this.selectedConnectionPoint = this._$stateParams['connectionPointGuid'];
        }

        this.exposedScope = {
            more: () => this.more(),
            less: () => this.less()
        };

        this._$scope.$watch(() => this.selectedConnectionPoint, () => {
            this.isDirty = !!this.selectedConnectionPoint;
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['selectedConnectionPoint']) {
            const selectedCP = changesObj['selectedConnectionPoint'].currentValue;
            this.isDirty = !!selectedCP;
        }
    }

    search() {
        if (this.selectedConnectionPoint && this.searchString) {
            this.isSearching = true;
            this._tagsImportService
                .search(this.selectedConnectionPoint, this.searchString)
                .then(result => {
                    this.pageNumber = 1;
                    this.results = result;
                    this.updateDisplayed();
                    this.pageCount = Math.ceil(this.results.length / this.pageSize);
                    this.newResultsCount = result.filter(t => !t.isAlreadyExisting).length;
                    //this.isDirty = false;
                    this.isSearching = false;
                })
                .catch(() => {
                    this._loggerService.logError('Failed to search.');
                    this.isSearching = false;
                });
        }
    }

    add(tagImportList: ImportedTagDefinition[]): void {
        this.addmethod({ tagImport: tagImportList });
    }

    more() {
        this.pageNumber++;
        this.updateDisplayed();
    }

    less() {
        this.pageNumber--;
        this.updateDisplayed();
    }

    select(tagImport: ImportedTagDefinition, $event: angular.IAngularEvent) {
        $event.preventDefault();
        const ev = this._$rootScope.$broadcast(tagSelected, tagImport.tagDefinition);
        if (!ev.defaultPrevented) {
            this.selectedImportTag = tagImport;
        }
    }

    private updateDisplayed() {
        this.displayed = _.take(this.results, this.pageNumber * this.pageSize);
        this.hasMore = this.results && this.displayed && this.displayed.length < this.results.length;
        this.hasLess = this.displayed.length > this.pageSize;
    }
}

export const wtDahsTagsSearch: ComponentDefinition = {
    componentId: 'wtDahsTagsSearch',
    controller: DahsTagsSearchController,
    template: require('./dahsTagsSearch.component.html'),
    controllerAs: 'vm',
    bindings: {
        results: '=',
        newResultsCount: '=',
        modal: '@',
        addmethod: '&',
        exposedScope: '=',
        hasMore: '=?',
        hasLess: '=?',
        displayed: '=?',
        hasModel: '@?',
        selectedConnectionPoint: '=?'
    }
};